export const name = 'gzL10nMissingTranslation';

export default function gzL10nMissingTranslation($log) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let missedIds = {};

  return missingTranslation;

  /////////////////

  function missingTranslation(translationId) {
    if(!missedIds[translationId]) {
      missedIds[translationId] = true;
      $log.warn("Missing translation: " + translationId);
    }
  }
}
